/** @format */
import { EntryType, Links, Renderers } from '@toucan/client/core/contentful';

import {
    ContentfulImageCompare,
    ContentfulImageWithCaption,
} from '@toucan/client/features/contentful';
import {
    contentfulCallToAction,
    contentfulContentAccordionToAccordion,
    contentfulEnhancedLinkDataToEnhancedLink,
    contentfulSectionPreviewBlockToSectionPreviewBlock,
    contentfulSiteContentCollection,
    contentfulSiteContentEmbed,
    contentfulTwoColumnWrapperToTwoColumn,
    contentfulVideoBlockToVideoBlock,
    findEntry,
    scriptToScriptTag,
} from '@toucan/client/features/contentful/helpers/adapters/contentful';

import { ContentfulAccordionGroup } from '../components/accordion-group';
import { ContentfulMasonryGrid } from '../components/masonry-grid';

export function getRenderers(
    type: EntryType,
    links?: Links,
    renderOverrides?: Renderers
) {
    const defaultRenderers: Renderers = {
        CallToAction: contentfulCallToAction,
        TwoColumnWrapper: contentfulTwoColumnWrapperToTwoColumn,
        SiteContentContentCollection: contentfulSiteContentCollection,
        SiteContentEmbed: contentfulSiteContentEmbed,
        SiteContentEnhancedLink: contentfulEnhancedLinkDataToEnhancedLink,
        SiteContentAccordion: contentfulContentAccordionToAccordion,
        SiteContentScript: scriptToScriptTag,
        SiteContentSectionPreviewBlock:
            contentfulSectionPreviewBlockToSectionPreviewBlock,
        SiteContentVideoBlock: contentfulVideoBlockToVideoBlock,
    };

    const componentRenderers: Renderers = {
        SiteContentImageWithCaption: ContentfulImageWithCaption,
        ImageCompare: ContentfulImageCompare,
        SiteContentAccordionGroup: ContentfulAccordionGroup,
        SiteContentMasonryGrid: ContentfulMasonryGrid,
    };

    const renderers = {
        ...defaultRenderers,
        ...componentRenderers,
        ...renderOverrides,
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    return (node: any) => {
        const entry = findEntry(node, links, type);

        if (!entry) {
            return null;
        }

        const typenames = Object.keys(renderers);
        const typename = typenames.find(
            (typename) => typename === entry.__typename
        );

        if (!typename) {
            return null;
        }

        const selectedRenderer = renderers[typename];

        return selectedRenderer(entry);
    };
}
